<template>
  <KActionBtn label="Export CSV" left-icon="export" right-icon="arrow-right" @click="exportTable" />
</template>

<script>
export default {
  name: 'KExportCsv',
}
</script>

<script setup>
import { exportFile } from 'quasar'
import { useRoute } from 'vue-router'

const props = defineProps({
  rows: { type: Array, required: true },
  columns: { type: Array, required: true },
  exportName: { type: String, default: '' },
})

const emit = defineEmits(['no-data', 'denied'])

const route = useRoute()

const wrapCsvValue = (val, formatFn) => {
  let formatted = formatFn !== void 0 && typeof formatFn === 'function' ? formatFn(val) : val
  formatted = formatted === void 0 || formatted === null ? '' : String(formatted)
  formatted = formatted.split('"').join('""')

  return `"${formatted}"`
}

const exportTable = () => {
  let tempExportName

  props.exportName
    ? (tempExportName = props.exportName.toLocaleLowerCase().replaceAll(' ', '-'))
    : (tempExportName = route?.name ?? 'csv-table')

  if (!props.rows.length) return emit('no-data')

  const columnsToExport = props.columns.filter((col) => col.export)
  const content = [columnsToExport.map((col) => wrapCsvValue(col.label))]
    .concat(
      props.rows.map((row) =>
        columnsToExport
          .map((col) =>
            wrapCsvValue(
              typeof col.field === 'function' ? col.field(row) : row[col.field === void 0 ? col.name : col.field],
              col.format,
            ),
          )
          .join(','),
      ),
    )
    .join('\r\n')

  const status = exportFile(`${tempExportName}.csv`, `\uFEFF${content}`, { mimeType: 'text/csv' })

  if (!status) emit('denied')
}
</script>
